import React, { ReactElement } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { FormContext } from '../FormContext';
import { FormControlProps } from '../types';
import { getStylingProps, getChildren, getFormElementProps, useReactHookForm, shouldRenderFormFooter } from './helpers';

const FormControl = ({ children, deps, ...restProps }: FormControlProps) => {
  const { FormHeader, FormElement, FormHelperText, FormCounter } = getChildren(children);
  const { errors, name, value, isFormError, isSuccess, maxLength } = useReactHookForm(restProps);
  const { wrapper, footer } = getStylingProps({ isError: isFormError, isSuccess });
  const { ref, onChange, onBlur, control } = getFormElementProps({
    ...(FormElement as ReactElement)?.props,
    name,
    deps,
  });

  return (
    <FormContext.Provider
      value={{
        maxLength,
        isError: isFormError,
        isSuccess,
        onChange,
        ref,
        onBlur,
        name,
        error: errors || (FormHelperText as ReactElement)?.props?.error,
        value,
        control,
      }}
    >
      <Stack {...wrapper}>
        {FormHeader}
        {FormElement}
        {shouldRenderFormFooter({
          FormHelperText,
          FormCounter,
          errors,
        }) && (
          <Box {...footer}>
            {FormHelperText}
            {FormCounter}
          </Box>
        )}
      </Stack>
    </FormContext.Provider>
  );
};

FormControl.displayName = 'FormControl';
export default FormControl;
